<template>
  <div class="gap-[16px] grid grid-cols-4 mt-[30px]">
    <ContentCharacterCard
      v-for="(item, index) in max ? data.slice(0, max) : data"
      :key="index"
      :data="item"
      class="h-[366px]"
      target="_blank"
      @change="onChange($event, item)"
    />
  </div>
</template>

<script lang="ts" setup>
import type { CharacterData } from '~/api/interface/search'
const props = defineProps<{
  max?: number
  data: CharacterData[]
}>()

const onChange = ([key, value]: [string, any], data: CharacterData) => {
  const item: any = props.data.find((item) => item.id === data.id)
  if (item) {
    item[key] = value
  }
}
</script>
